import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ViewActionRequiredModule"
const debug = false

export class ViewActionRequiredModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.VIEW_ACTION_REQUIRED, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                     = "Action required"
        this.description              = ""
        this.svgIcon                  = "isvg-view-action-required"
        this.settingsMenuTopCategory  = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                = "Views"
        this.settingsUrl              = "settings/view-action-required"
        this.parentSection              = SettingsParentSection.VIEWS

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}